import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ConfigCheck from '../../../../components/ConfigCheck'
import Assessment from './assessment'
import moment from 'moment'
import Timer from 'components/Timer'
import LoadingSpinner from '../../../../components/LoadingSpinner'




import {
  PageContainer,
  ContentWrapper,
  Header,
  Title,
  TakeButton,
  AssessmentDetails,
  AssessmentName,
  InstructionDeadlineSection,
  InstructionDeadlineLabel,
  InstructionDeadlineInfo,
  InstructionTimeLeft,
  InstructionDateTime,
  InstructionTime,
  List,
  SubList,
  ListItem,
  StartButton,
  SectionTitle,
  InstructionSection,
  InstructionText,
  Separator,
  BackButton,
  ButtonGroup
} from '../../Style'

const BehaviourInstructions = ({
  assessment,
  questions,
  totalQuestions,
  error,
  responses,
  fetchAssessmentQuestions,
  saveQuestionResponse,
  studentId,
  setAssessment 
}) => {
  
  const location = useLocation()
  
  // Group all useState hooks together at the top
  const [loading, setLoading] = useState(true)
  const [showConfig, setShowConfig] = useState(false)
  const [allChecksComplete, setAllChecksComplete] = useState(false)
  const [showAssessment, setShowAssessment] = useState(false)
  const [isTimerActive, setIsTimerActive] = useState(false)
  const [countdown, setCountdown] = useState(null)
  const [timerPhase, setTimerPhase] = useState('initial')

  // Group useEffects together
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [])

  useEffect(() => {
    console.log(assessment)
    if (assessment?.assessment_set_id) {
      fetchAssessmentQuestions(assessment.assessment_set_id)
    }
  }, [assessment?.assessment_set_id, fetchAssessmentQuestions])

  // Early return for loading state
  if (loading) {
    return <LoadingSpinner />
  }

  const handleTakeAssessment = () => {
    setShowConfig(true)
  }

  const handleBack = () => {
    console.log('Back button clicked');
    setAssessment(null);
  }
  const handleStart = () => {
    if (!allChecksComplete) return;
    
    setIsTimerActive(true);
    setTimerPhase('initial');
    
    // Phase 1: Show "Timer starts now" for 2 seconds
    setTimeout(() => {
      setTimerPhase('countdown');
      setCountdown(3);
      
      // Phase 2: Start countdown
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            setTimerPhase('start');
            
            // Phase 3: Show Start! and begin assessment
            setTimeout(() => {
              setShowAssessment(true);
            }, 1000);
            
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }, 2000);
  };

  const handleConfigComplete = (complete) => {
    setAllChecksComplete(complete)
  }

  const formatDate = (dateTime) => {
    if (!dateTime) return ''
    return moment(dateTime).format('DD/MM/YYYY')
  }

  const formatTime = (dateTime) => {
    if (!dateTime) return ''
    return moment(dateTime).format('hh:mm A')
  }

  const calculateDaysLeft = (endTime) => {
    if (!endTime) return ''
    const now = moment()
    const end = moment(endTime)
    const days = end.diff(now, 'days')
    return `${days} days left`
}

if (showAssessment) {
  return (
    <Assessment
      questions={questions}
      totalQuestions={totalQuestions}
      loading={loading}
      error={error}
      responses={responses}
      saveQuestionResponse={saveQuestionResponse}
      startTime={new Date()}
    />
  )
}


  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error}</div>
  }

  return (
    <PageContainer>
      <ContentWrapper>
        
      <Header>
  <Title>Behavioral Assessment</Title>
  {!showConfig && !isTimerActive && (
    <ButtonGroup>
      <BackButton onClick={handleBack}>Back</BackButton>
      <TakeButton onClick={handleTakeAssessment}>Take Assmt.</TakeButton>
    </ButtonGroup>
  )}
</Header>

        {isTimerActive ? (
          <Timer 
            timerPhase={timerPhase}
            countdown={countdown}
          />
        ) : (
          <>
            <AssessmentDetails>
              <AssessmentName>
                Assessment Name : {assessment?.title || 'Behavioral Assessment'}
              </AssessmentName>
              <InstructionDeadlineSection>
                <InstructionDeadlineLabel>Deadline</InstructionDeadlineLabel>
                <InstructionDeadlineInfo>
                  <InstructionTimeLeft>{calculateDaysLeft(assessment?.endTime)}</InstructionTimeLeft>
                  <InstructionDateTime>{formatDate(assessment?.endTime)}</InstructionDateTime>
                  <InstructionTime>{formatTime(assessment?.endTime)}</InstructionTime>
                </InstructionDeadlineInfo>
              </InstructionDeadlineSection>
            </AssessmentDetails>

            {showConfig ? (
              <>
                <ConfigCheck
                  onAllChecksComplete={() => setAllChecksComplete(true)}
                />
                <StartButton
                  allChecksComplete={allChecksComplete}
                  onClick={handleStart}
                  disabled={!allChecksComplete}
                >
                  Start Assessment
                </StartButton>
              </>
            ) : (
              <>
                <InstructionSection>
                  <SectionTitle>Assessment Instructions</SectionTitle>
                  <InstructionText>
                    You will have a total of 5 minutes to complete all tasks. Manage
                    your time wisely as you progress through the following sections
                  </InstructionText>
                </InstructionSection>

                <InstructionSection>
                  <SectionTitle>General Guidelines:</SectionTitle>
                  <List>
                    <ListItem>
                      Objective: This assessment aims to evaluate behavioral traits,
                      decision-making, and interpersonal skills.
                    </ListItem>
                    <ListItem>
                      Duration: The assessment is time-bound. You will have [insert
                      time limit, e.g., 30 minutes] to complete all questions.
                    </ListItem>
                    <ListItem>
                      Attempt: You are allowed to take this assessment only once.
                      Ensure you are in a distraction-free environment before
                      starting.
                    </ListItem>
                    <ListItem>
                      Question Format:
                      <SubList>
                        <ListItem>
                          The assessment consists of multiple-choice questions
                          (MCQs).
                        </ListItem>
                        <ListItem>
                          Each question will have 4 options; you must choose the
                          most appropriate answer.
                        </ListItem>
                        <ListItem>
                          Some questions may require selecting more than one option
                          (if specified).
                        </ListItem>
                      </SubList>
                    </ListItem>
                  </List>
                </InstructionSection>

                <Separator />

                <InstructionSection>
                  <SectionTitle>Proctoring Instructions</SectionTitle>

                  <SectionTitle>Technical Setup</SectionTitle>
                  <List>
                    <ListItem>Ensure a stable internet connection.</ListItem>
                    <ListItem>
                      Use a laptop/desktop equipped with a working webcam,
                      microphone, and speakers.
                    </ListItem>
                  </List>

                  <SectionTitle>Environment</SectionTitle>
                  <List>
                    <ListItem>
                      Sit in a well-lit, quiet environment with minimal background
                      noise.
                    </ListItem>
                    <ListItem>
                      Avoid any distractions or interruptions during the assessment.
                    </ListItem>
                  </List>

                  <SectionTitle>Behavior</SectionTitle>
                  <List>
                    <ListItem>
                      Do not switch tabs or use unauthorized resources.
                    </ListItem>
                    <ListItem>
                      Stay focused and remain within the assessment interface
                      throughout the session.
                    </ListItem>
                  </List>

                  <SectionTitle>Monitoring</SectionTitle>
                  <List>
                    <ListItem>
                      The system will monitor your screen, webcam, microphone, and
                      audio for proctoring purposes.
                    </ListItem>
                    <ListItem>
                      Ensure you are visibly present throughout the assessment.
                    </ListItem>
                  </List>

                  <SectionTitle>Prohibited Items</SectionTitle>
                  <List>
                    <ListItem>
                      Headphones, mobile phones, or any external resources (e.g.,
                      notes, books) are strictly prohibited.
                    </ListItem>
                  </List>

                  <SectionTitle>Support</SectionTitle>
                  <List>
                    <ListItem>
                      In case of technical issues, contact the support team
                      immediately using the provided details.
                    </ListItem>
                  </List>
                </InstructionSection>
              </>
            )}
          </>
        )}
      </ContentWrapper>
    </PageContainer>
  )
}



export default BehaviourInstructions